import { render, staticRenderFns } from "./HomeGame.vue?vue&type=template&id=4d104548&scoped=true"
import script from "./HomeGame.vue?vue&type=script&lang=js"
export * from "./HomeGame.vue?vue&type=script&lang=js"
import style0 from "./HomeGame.vue?vue&type=style&index=0&id=4d104548&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d104548",
  null
  
)

export default component.exports